import Vue from 'vue';
import App from './App.vue';

import VueRouter from 'vue-router';

Vue.use(VueRouter);

import showToast from '@/components/toast/index'

Vue.use(showToast);


const router = new VueRouter({
    mode: 'history',
    routes: [
        {
            path: '/',
            component: () => App,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/index.html',
            component: () => App,
            meta: {
                keepAlive: true
            }
        },
        {
            path: '/home',
            component: () => import('./pages/home'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/terms',
            component: () => import('./pages/terms')
        },
        {
            path: '/purchase',
            component: () => import('./pages/purchase'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/purchase-history',
            component: () => import('./pages/purchase-history'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/transfer',
            component: () => import('./pages/transfer'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/transfer-history',
            component: () => import('./pages/transfer-history'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/customer',
            component: () => import('./pages/customer'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/customer_h5',
            component: () => import('./pages/customer_h5'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/withdraw',
            component: () => import('./pages/withdraw'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/test',
            component: () => import('./pages/test.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/withdrawAdd',
            component: () => import('./pages/withdraw-add.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/withdrawModify',
            component: () => import('./pages/withdraw-modify.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/withdrawDetail',
            component: () => import('./pages/withdraw-detail.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/privacyPolicy',
            component: () => import('./pages/privacy-policy.vue'),
            meta: {
                keepAlive: false
            }
        }, {
            path: '/privacyPolicy_cocos',
            component: () => import('./pages/privacy-policy.vue'),
            meta: {
                keepAlive: false
            }
        },
        {
            path: '/termsOfService',
            component: () => import('./pages/terms-of-service.vue'),
            meta: {
                keepAlive: false
            }
        },{
            path: '/termsOfService_cocos',
            component: () => import('./pages/terms-of-service.vue'),
            meta: {
                keepAlive: false
            }
        },

        {
            path: '*',
            redirect: '/'
        }
    ]
});

import VueClipboard from 'vue-clipboard2';
// import VueClipboard from 'vue3-clipboard'

Vue.use(VueClipboard);

import i18n from '@/lang';

import logger from '@/utils/logger';

Vue.prototype.$log = logger;

Vue.config.productionTip = false;

let padding = function(d) {
    return d >= 10 ? `${d}` : `0${d}`;
}
let monthes = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', ];

Vue.filter('formatDate', d => {
    return `${monthes[d.getMonth()]} ${d.getDate()}, ${d.getFullYear()}`;
});
Vue.filter('formatTime', d => {
    return `${padding(d.getHours())}:${padding(d.getMinutes())}:${padding(d.getSeconds())}`;
});

Vue.filter('formatNum', d => {
    return (d || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
});

Vue.filter('formatPrice', d => {
    d = (d || 0).toFixed(2);
    let nums = d.split('.', 2);
    // return nums[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,') + '.' + nums[1];
    return nums[0].replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
});

import message from 'ant-design-vue/lib/message';
message.config({
    duration: 3,
    maxCount: 1
});

import { Radio } from 'ant-design-vue';
// import 'ant-design-vue/lib/radio/style/index.css';
import '@/assets/css/antv-radio.css';
Vue.use(Radio);

import { Drawer } from 'ant-design-vue';
import 'ant-design-vue/lib/drawer/style/css'
Vue.use(Drawer);

import { BackTop } from 'ant-design-vue';
import 'ant-design-vue/lib/back-top/style/css'
Vue.use(BackTop);

import { Carousel, CarouselItem ,Collapse,CollapseItem} from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.component(Carousel.name, Carousel);
Vue.use(CarouselItem);
Vue.component(Collapse.name, Collapse);
Vue.use(CollapseItem);


import { Tabs, TabPane,  } from 'element-ui';
Vue.component(Tabs.name, Tabs);
Vue.use(TabPane);

import VueLoadmore from 'vuejs-loadmore';

Vue.use(VueLoadmore, {
    lang: 'en-US'
  });
// import { Drawer  } from 'element-ui';
// Vue.use(Drawer);

import VueLazyload from 'vue-lazyload';

Vue.use(VueLazyload, {
    attempt: 1
});

import request from '@/utils/request';

Vue.prototype.$http = request;

//状态管理
import Vuex from 'vuex';
Vue.use(Vuex);
const store = new Vuex.Store({
    state: {
        balance: 0,
        user: {},
    },
    mutations: {
        setBalance(state, balance) {
            state.balance = balance;
        },
        setUser(state, user) {
            state.user = user;
        },

    }
});

new Vue({
    store,
    router,
    i18n,
    render: h => h(App)
}).$mount('#app');



